import { ApplicationState } from 'AppReducer'
import React from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { formatDateTime } from 'util/masks'
import Pagination from 'util/modules/Pagination'
import { getNotificationList } from '../redux/actions'

const NotificationList: React.FC = () => {
  const dispatch = useDispatch()

  const { notifications: { items, pagination } } = useSelector((state: ApplicationState) => state.notificationReducer)

  const history = useHistory()
  const { location: { search } } = history

  function handleFetch (): void {
    const query = new URLSearchParams(search)
    getNotificationList({
      fields: 'id,title,message,quantitySend,quantityOpen,quantitySms,createdAt',
      page: query.get('page') || 1,
      limit: 10,
      'sort[createdAt]': 'DESC'
    })(dispatch)
  }

  useEffect(() => {
    handleFetch()
    // eslint-disable-next-line
  }, [search])

  const gridTemplateColumns = '300px 1fr 100px 100px 100px 200px'

  return (
    <div className="row">
      <div className="row justify-start margin-top-24">
        <h2><i className="fa fa-1x fa-history"/>Histórico</h2>
      </div>
      <div className="list">
        <div className="list-header" style={{ display: 'grid', gridTemplateColumns }}>
          <div>Título</div>
          <div>Mensagem</div>
          <div>Envios</div>
          <div>Aberto</div>
          <div>SMS</div>
          <div>Data</div>
        </div>
        {
          items.length === 0 &&
          <div className="list-row">
            <div className="grid-span">Nenhuma notificação</div>
          </div>
        }
        {
          items.map((item, i) => (
            <div className="list-row" style={{ display: 'grid', gridTemplateColumns }} key={i}>
              <div>{ item.title }</div>
              <div>{ item.message }</div>
              <div>{ item.quantitySend }</div>
              <div>{ item.quantityOpen }</div>
              <div>{ item.quantitySms }</div>
              <div>{ formatDateTime(item.createdAt) }</div>
            </div>
          ))
        }
      </div>

      <Pagination pagination={pagination} />
    </div>
  )
}

export default NotificationList
